<div style="width: 100%; text-align: center;">
    <div class="contentContainer" style="margin-top: 100px;">

        <p style="font-weight: bold; font-size: 18px;">
            Please visit our nearest office or KIOSK center to generate update request.
            This is required for the Biometric authentication.
        </p>
        <p style="font-weight: bold; font-size: 18px;">
            Thank You
        </p>
    </div>
</div>